import React from "react";
import { Row, Col, Space, message, Modal, Button, Image, Drawer, Tooltip } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import VehicleFuelCalibrationStore from "../store/VehicleFuelCalibrationStore";
import withRouter from "../withRouter";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import ListTable from "./ListTable";
import VehicleFuelCalibrationAdd from "./VehicleFuelCalibrationAdd";

class VehicleFuelCaliborationList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);

    this.vehicleFuelCaliborationStore = new VehicleFuelCalibrationStore();

    this.state = {
      loading: false,
      offset: 0,
      limit: 50,
      pageSize: 50,
      currentPage: 1,
      fuelCalibrationId: "",
      openVehicleCalibrationForm: false,
      listDataUpdate: false,

      openDeleteModal: false,

      deleteData: {},
    };

    this.columns = [
      {
        // title: " Fuel Calibration Name ",
        title: context.translate("_FUEL_CALIBRATION_NAME_"),
        dataIndex: "fuelCalibrationName",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate('VehicleFuelCalibrationList')  && this.onEdit(record);
              }}
            >
              {value}
            </Link>
          );
        },
      },
      {
        // title: "Fuel Tank Capacity ",
        title: context.translate("_FUEL_TANK_CAPACITY_"),
        dataIndex: "fuelTankCapacity",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Max Voltage ",
        title: context.translate("_MAX_VOLTAGE_"),
        dataIndex: "maxVoltage",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Min Voltage ",
        title: context.translate("_MIN_VOLTAGE_"),
        dataIndex: "minVoltage",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        align: "center",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>

                <Tooltip
                  title={context.translate("_FLEET_COMPANY_COMPANYLIST_EDIT_")}
                  placement="bottom"
                >

                  {this.props.canUpdate('VehicleFuelCalibrationList') &&  <Image
                    style={{
                      height: "19px",
                      width: "15px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>}
                </Tooltip>
                <Tooltip

                  title={context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                  placement="bottom"
                >

                {this.props.canDelete('VehicleFuelCalibrationList') &&   <Image
                    src={require("../assets/images/NewDesign/Delete.png")}
                    style={{ cursor: "pointer", width: "15px", }}
                    onClick={() =>
                      this.setState({
                        openDeleteModal: true,
                        deleteData: record,
                      })
                    }
                  ></Image>}
                </Tooltip>

                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit"
                    title={context.translate("_FLEET_COMPANY_COMPANYLIST_EDIT_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete"
                      title={context.translate(
                        "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}
              </Space>
            </>
          );
        },
      },
    ];
  }

  onEdit = async (record) => {
    console.log("id", record.Id);
    // this.props.navigate("/vehiclefuelcalibration/" + record.Id);
    await this.setState({ fuelCalibrationId: record.Id });
    await this.setState({ openVehicleCalibrationForm: true });
  };

  async componentDidMount() {
    await this.vehicleFuelCaliborationStore.loadData({ offset: 0, limit: 50 });

    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleFuelCaliborationStore.loadData({
      offset: this.state.currentPage - 1,
      limit: this.state.pageSize,
      currentPage: this.state.currentPage,
    });
    this.setState({ loading: false });
  }

  async onDelete(record) {
    console.log(record.Id, "record");
    const response = await this.vehicleFuelCaliborationStore.deleteRecord({
      Id: record.Id,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // this.props.navigate("/vehiclefuelcalibrationlist");

      this.setState({ openVehicleCalibrationForm: false });
      await this.vehicleFuelCaliborationStore.loadData({
        offset: 0,
        limit: 50,
      });
      this.setState({ listDataUpdate: true });
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["username"]);
      });
    }
  };

  closeModal = () => {
    this.setState({
      openVehicleCalibrationForm: false,
      fuelCalibrationId: "",
    });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.vehicleFuelCaliborationStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FUEL_CALIBRATION_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  // title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  placement="left"
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() =>
                      this.setState({
                        openVehicleCalibrationForm: true,
                        fuelCalibrationId: "",
                      })
                    }
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}></Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip title={this.context.translate("_REFRESH_")} placement="bottom">
              <Image
                style={{
                  height: 18,
                  alignItems: "center",
                  cursor: "pointer",
                  marginInlineEnd: "20px",
                }}
                src={refreshIcon}
                onClick={() => this.refreshList()}
              ></Image>
  </Tooltip>


{this.props.canCreate('VehicleFuelCalibrationList') && <Button

                className="addButtonClass"
                onClick={() =>
                  this.setState({
                    openVehicleCalibrationForm: true,
                    fuelCalibrationId: "",
                  })
                }
              >
                <Image
                  style={{ marginInlineEnd: "5px", width: 13 }}
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                ></Image>
                {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
              </Button>}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.vehicleFuelCaliborationStore?.total}
            columns={this.columns}
            dataSource={
              this.vehicleFuelCaliborationStore?.vehicleFuelCalibrationVehicles
            }
            loading={this.vehicleFuelCaliborationStore?.loading}
            onChange={this.handleTableChange}
          // pagination={{
          //   pageSize: this.state.pageSize,
          //   total: this.vehicleFuelCaliborationStore.total || 0,
          // }}
          />
        </div>

        {this.state.openVehicleCalibrationForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Fuel Calibration"
          //   title={this.context.translate("_FUEL_CALIBRATION_")}
          //   centered
          //   visible={this.state.openVehicleCalibrationForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({
          //       openVehicleCalibrationForm: false,
          //       fuelCalibrationId: "",
          //     });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehicleCalibrationForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FUEL_CALIBRATION_")}
                <p className="formDescription">
                  {this.context.translate(
                    "_VEHICLE_FUEL_CALIBRATION_ADD_DESC_"
                  )}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehicleCalibrationForm: false })}
            onCancel={() =>
              this.setState({
                openVehicleCalibrationForm: false,
                fuelCalibrationId: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleFuelCalibrationAdd
                fuelCalibrationId={this.state.fuelCalibrationId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleFuelCaliborationList.contextType = StoreContext;
export default observer(withRouter(VehicleFuelCaliborationList));
